// src/components/FinalCTA.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaCheck } from 'react-icons/fa';

const FinalCTA = () => {
  const { t } = useTranslation();

  return (
    <section id="cta" className="relative py-20 md:py-32 bg-gradient-to-b from-white via-primary/5 to-white">
      {/* Background decorative elements */}
      <div className="absolute inset-0 pointer-events-none">
        {/* Top right blob */}
        <div 
          className="absolute top-0 right-0 w-[500px] h-[500px] bg-gradient-to-br from-primary/10 to-accent/5 rounded-full blur-[128px] -translate-y-1/2 translate-x-1/2"
          style={{ mixBlendMode: 'multiply' }}
        ></div>
        {/* Bottom left blob */}
        <div 
          className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-gradient-to-tr from-accent/10 to-primary/5 rounded-full blur-[128px] translate-y-1/2 -translate-x-1/2"
          style={{ mixBlendMode: 'multiply' }}
        ></div>
        {/* Center subtle glow */}
        <div 
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-gradient-to-r from-primary/5 via-accent/5 to-primary/5 rounded-full blur-[96px]"
          style={{ mixBlendMode: 'overlay' }}
        ></div>
      </div>

      <div className="relative max-w-5xl mx-auto px-4 z-10">
        <div className="bg-white/90 backdrop-blur-2xl rounded-3xl shadow-2xl p-8 md:p-12 border border-white/20">
          {/* Main content container */}
          <div className="text-center space-y-8">
            {/* Badge */}
            <div className="inline-flex items-center px-4 py-2 bg-primary/10 rounded-full text-primary font-medium text-sm mb-4 border border-primary/20">
              <span className="animate-pulse mr-2">🎯</span>
              {t('finalCTA.badge')}
            </div>

            {/* Title and description */}
            <div className="space-y-6">
              <h2 className="text-3xl md:text-5xl font-extrabold bg-gradient-to-r from-primary via-primary to-accent bg-clip-text text-transparent">
                {t('finalCTA.title')}
              </h2>
              <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed">
                {t('finalCTA.description')}
              </p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
              <div className="p-4 rounded-lg bg-white/10">
                <p className="font-bold text-xl">{t('finalCTA.stats.support')}</p>
              </div>
              <div className="p-4 rounded-lg bg-white/10">
                <p className="font-bold text-xl">{t('finalCTA.stats.satisfaction')}</p>
              </div>
            </div>

            {/* CTA Button with floating effect */}
            <div className="relative group">
              <div className="absolute -inset-0.5 bg-gradient-to-r from-warning to-orange-300 rounded-xl blur opacity-30 group-hover:opacity-60 transition duration-300 group-hover:duration-200"></div>
              <button
                onClick={() => {
                  const pricingSection = document.getElementById('tarifs');
                  if (pricingSection) {
                    pricingSection.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
                className="relative flex items-center justify-center space-x-3 px-8 py-4 text-lg font-bold text-white bg-warning rounded-xl shadow-lg transition-all duration-300 hover:scale-102 active:scale-98 hover:shadow-xl w-full"
              >
                <span>{t('finalCTA.button')}</span>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              </button>
            </div>

            <div className="pt-10 space-y-8">
              <div className="mt-6 flex flex-col md:flex-row items-center justify-center gap-4 text-sm opacity-90">
                <div className="flex items-center">
                  <FaCheck className="mr-2" /> {t('finalCTA.supportText', 'Support client dédié')}
                </div>
                <div className="flex items-center">
                  <FaCheck className="mr-2" /> {t('finalCTA.satisfactionText', 'Garantie satisfait ou remboursé 7 jours')}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
